import {CommentsCategory} from '@domain/comments'
import type {MaterialOrderPermissions} from '@features/storage-levels'
import {usePlantPermission} from '@hproduce/permissions'

import {checkPermissionCommentCategory} from './checkPermissionCommentCategory'

/**
 * Resolves the storage-levels material order permissions for HCEM, which still enforces
 * plant permissions. The resolved object is passed to `MaterialOrderPermissionsProvider`
 * so the (permission-agnostic) storage-levels feature can gate its UI.
 */
export const useStockMaterialOrderPermissions = (): MaterialOrderPermissions => {
  const canViewMaterialOrders = usePlantPermission('VIEW_MATERIAL_ORDERS')
  const canChangeMaterialOrders = usePlantPermission('CHANGE_MATERIAL_ORDERS')
  const canViewComments = usePlantPermission(
    'VIEW_COMMENTS',
    checkPermissionCommentCategory(CommentsCategory.MaterialOrders)
  )
  const canEditComments = usePlantPermission(
    'EDIT_COMMENTS',
    checkPermissionCommentCategory(CommentsCategory.MaterialOrders)
  )
  const canViewDocuments = usePlantPermission('VIEW_DOCUMENTS')
  const canAddDocuments = usePlantPermission('ADD_DOCUMENTS')
  const canDeleteDocuments = usePlantPermission('DELETE_DOCUMENTS')

  return {
    canViewMaterialOrders,
    canChangeMaterialOrders,
    canViewComments,
    canEditComments,
    canViewDocuments,
    canAddDocuments,
    canDeleteDocuments
  }
}
